import type { CSSObject } from "type/tss";
import { Theme } from "@mui/material/styles";
import { baseColors } from "theme";

export const styles = (theme: Theme) => ({
	bar: {
		display: "flex",
		alignItems: "center",
		justifyContent: "space-between",
		gap: theme.spacing(2),
		marginBottom: theme.spacing(2),
		flexWrap: "wrap",
	},
	// The design system's compact Banner: 46px tall, the icon and text centred, 4px corners.
	source: {
		alignItems: "center",
		height: 46,
		boxSizing: "border-box",
		padding: "0 8px 0 16px",
		borderRadius: 4,
		backgroundColor: theme.palette.custom.tagPrimarySurface,
		color: theme.palette.custom.textPrimary,
		"& .MuiAlert-icon": {
			alignItems: "center",
			padding: 0,
			marginRight: theme.spacing(1),
			color: theme.palette.primary.main,
		},
		"& .MuiAlert-message": {
			padding: 0,
		},
	},
	tools: {
		display: "flex",
		alignItems: "center",
		gap: theme.spacing(3),
		marginLeft: "auto",
		flexWrap: "wrap",
	},
	// The design system's SegmentedControl: a white 8px card, 4px padding, 46px tall, with 36px segments; the selected one
	// is filled teal.
	segmented: {
		boxSizing: "border-box",
		height: 46,
		padding: theme.spacing(0.5),
		backgroundColor: theme.palette.common.white,
		border: `1px solid ${theme.palette.custom.border}`,
		borderRadius: 8,
		"& .MuiToggleButtonGroup-grouped": {
			height: 36,
			margin: 0,
			padding: theme.spacing(0, 2),
			border: 0,
			borderRadius: 6,
			textTransform: "none",
			fontSize: 16,
			lineHeight: "20px",
			fontWeight: 600,
			color: theme.palette.custom.textPrimary,
			"&:not(:first-of-type)": {
				borderRadius: 6,
				marginLeft: 0,
			},
			"&:hover": {
				backgroundColor: baseColors.gray100,
			},
			"&.Mui-selected, &.Mui-selected:hover": {
				backgroundColor: baseColors.teal400,
				color: theme.palette.common.white,
			},
		},
	},
} satisfies Record<string, CSSObject>);
